<template>
	<MyCity v-model="provAndCity" />
</template>

<script>
	//引入联动子组件
	import MyCity from '@/components/erjiliandong/companys/companys-add.vue'
	export default {
		components: {
			MyCity
		},
		data() {
			return {
				provAndCity: {
					province: '', // 城市
					city: ''
				},
			}
		},
	}
</script>
